
export const formatLondonTooltip = (iso?: string | null): string | undefined => {
    if (!iso) return undefined
    const date = new Date(iso)
    if (Number.isNaN(date.getTime())) return undefined
    return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC',
    }).replace(/(\d{4}),\s*/, '$1 ') + ', London time, UTC'
}